<template>
  <div class="modal-card" :class="classes" @click.stop>
    <ModalTitle v-if="title">
      {{ titleText }}
    </ModalTitle>
    <button
      v-if="closable"
      class="modal-card__close"
      title="Закрыть"
      @click="$emit('close')"
    >
      <svg-icon size="18" icon-name="close" />
    </button>
    <div class="modal-card__body">
      <slot />
    </div>
  </div>
</template>

<script>
import ModalTitle from "./ModalTitle";

export default {
  name: "ModalCard",
  components: {
    ModalTitle
  },
  props: {
    closable: Boolean,
    title: [Boolean, String]
  },
  computed: {
    titleText() {
      return this.title === true ? "" : this.title;
    },
    classes() {
      return {
        "modal-card_titled": !!this.title,
        "modal-card_closable": this.closable
      };
    }
  }
};
</script>

<style lang="scss">
$p: ".modal-card";

.modal-card {
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.5);
  padding: 75px 30px 35px;
  max-width: 910px;
  margin: 0 auto;
  position: relative;
  width: 100%;
  z-index: 1;
  min-height: 150px;
  color: colors(text-2);

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    background-color: #fff;
  }

  .modal-title {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }

  &__close {
    position: absolute;
    top: 30px;
    right: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    color: #fff;
    cursor: pointer;
    border: none;
    outline: none;
    z-index: 2;

    &:hover {
      color: colors(palette-5);
    }
  }

  &_titled {
    padding-top: 125px;
    &::after {
      top: 40px;
    }
  }

  @include breakpoint("sm-and-down") {
    padding: 20px;
    padding-top: 125px;
    &__close {
      right: 10px;
    }
  }

  @include breakpoint("xs-only") {
    padding: 16px;
    padding-top: 125px;
  }
}
</style>
